import { cacheDecorator } from '@ds/swymkit/tools'

import { messagingFetch } from '~/services/fetch-messaging'

async function _getMaxUsersAllowed() {
  const data = await messagingFetch
    .get('/conversation/maxUsersPerConv')
    .json<{ maxUsersPerConv: number }>()

  return data.maxUsersPerConv
}

/**
 * Retrieves the maximum number of users allowed in an RT conversation
 *
 * @returns The number of users. E.g: It is now set to 100
 */
export function getMaxUsersAllowed() {
  return cacheDecorator(
    'rtc-max-users-per-conv',
    _getMaxUsersAllowed,
    60 * 1000, // 1 minute
  )
}

export async function _getRTConversationId(legacyId: string) {
  const data = await messagingFetch
    .get(`/conversation/idFromLegacy?legacyUri=${legacyId}`)
    .json<{ rtconvId: number }>()

  return data.rtconvId
}

/**
 * Retrieve the RTConversation id from the legacy URI of the conversation after the migration.
 *
 * @returns Id of the RTConversation
 */
export function getRTConversationId(legacyId: string) {
  return cacheDecorator(
    'rtc-id-from-legacy-conv',
    () => _getRTConversationId(legacyId),
    60 * 1000,
  )
}
